'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
function $p_Lapp_utils_UserAttention$Dom$__updateSignal__V($thiz) {
  var this$1 = $thiz.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar;
  var this$2 = this$1.signal__Lcom_raquo_airstream_state_StrictSignal();
  if ((!(!this$2.tryNow__s_util_Try().get__O()))) {
    var $x_1 = true;
  } else {
    var this$3 = $thiz.Lapp_utils_UserAttention$Dom$__f_badgeState;
    var $x_1 = (!this$3.isEmpty__Z());
  }
  if ($x_1) {
    if ($thiz.Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState.isEmpty__Z()) {
      var currentTick = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_sr_LongRef($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0);
      var timerId = ($j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().setInterval((() => {
        $p_Lapp_utils_UserAttention$Dom$__tick$1__sr_LongRef__V($thiz, currentTick);
      }), 1000.0) | 0);
      var value = new $c_Lapp_utils_UserAttention$Dom$TimerState(timerId);
      $thiz.Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(value);
    }
  } else {
    var this$8 = $thiz.Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState;
    if ((!this$8.isEmpty__Z())) {
      var x0 = this$8.get__O();
      x0.stop__V();
    }
  }
}
export { $p_Lapp_utils_UserAttention$Dom$__updateSignal__V as $p_Lapp_utils_UserAttention$Dom$__updateSignal__V };
function $p_Lapp_utils_UserAttention$Dom$__calculatePrefix$1__sr_LongRef__s_Option($thiz, currentTick$1) {
  var this$1 = $thiz.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar;
  var this$2 = this$1.signal__Lcom_raquo_airstream_state_StrictSignal();
  var _1 = this$2.tryNow__s_util_Try().get__O();
  var _2 = $thiz.Lapp_utils_UserAttention$Dom$__f_badgeState;
  var x13 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_T2__O__O__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_T2(), _1, _2);
  var x20 = (!(!x13.T2__f__1));
  var x21 = x13.T2__f__2;
  if ((x20 === false)) {
    var x = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var $x_1 = (x === x21);
  } else {
    var $x_1 = false;
  }
  if ($x_1) {
    return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  }
  if ((x20 === true)) {
    var x$3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    var $x_2 = (x$3 === x21);
  } else {
    var $x_2 = false;
  }
  if ($x_2) {
    var a = currentTick$1.sr_LongRef__f_elem;
    var this$4 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    var lo = this$4.remainderImpl__I__I__I__I__I(a.RTLong__f_lo, a.RTLong__f_hi, 2, 0);
    var hi = this$4.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo === 0) && (hi === 0))) {
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some("(!)");
    }
    if (((lo === 1) && (hi === 0))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi));
  }
  if ((x21 instanceof $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some)) {
    var n = (x21.s_Some__f_value | 0);
    var a$1 = currentTick$1.sr_LongRef__f_elem;
    var this$10 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_RTLong$();
    var lo$1 = this$10.remainderImpl__I__I__I__I__I(a$1.RTLong__f_lo, a$1.RTLong__f_hi, 2, 0);
    var hi$1 = this$10.RTLong$__f_org$scalajs$linker$runtime$RuntimeLong$$hiReturn;
    if (((lo$1 === 0) && (hi$1 === 0))) {
      var $x_3 = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$ShowInterpolator$();
      var parts = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().wrapRefArray__AO__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_T.getArrayOf().constr)(["(", ")"]));
      var sc = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_StringContext(parts);
      var a$2 = $x_3.show$extension__s_StringContext__sci_Seq__T(sc, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$().genericWrapArray__O__sci_ArraySeq(new ($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$d_Lcats_Show$Shown.getArrayOf().constr)([new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_Lcats_Show$Shown($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_Show$Shown$().mat__O__Lcats_Show$ContravariantShow__T(n, $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcats_instances_package$int$().Lcats_instances_package$int$__f_catsStdShowForInt))])));
      return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Some(a$2);
    }
    if (((lo$1 === 1) && (hi$1 === 0))) {
      return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
    }
    throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo$1, hi$1));
  }
  throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x13);
}
export { $p_Lapp_utils_UserAttention$Dom$__calculatePrefix$1__sr_LongRef__s_Option as $p_Lapp_utils_UserAttention$Dom$__calculatePrefix$1__sr_LongRef__s_Option };
function $p_Lapp_utils_UserAttention$Dom$__tick$1__sr_LongRef__V($thiz, currentTick$2) {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V($thiz.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixVar, $p_Lapp_utils_UserAttention$Dom$__calculatePrefix$1__sr_LongRef__s_Option($thiz, currentTick$2));
  var b = currentTick$2.sr_LongRef__f_elem;
  var blo = b.RTLong__f_lo;
  var lo = ((1 + blo) | 0);
  var hi = ((b.RTLong__f_hi + (((blo & (~lo)) >>> 31) | 0)) | 0);
  currentTick$2.sr_LongRef__f_elem = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_RTLong(lo, hi);
  var a = currentTick$2.sr_LongRef__f_elem;
  var ahi = a.RTLong__f_hi;
  if ((ahi < 0)) {
    currentTick$2.sr_LongRef__f_elem = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$L0;
  }
}
export { $p_Lapp_utils_UserAttention$Dom$__tick$1__sr_LongRef__V as $p_Lapp_utils_UserAttention$Dom$__tick$1__sr_LongRef__V };
/** @constructor */
function $c_Lapp_utils_UserAttention$Dom$() {
  this.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar = null;
  this.Lapp_utils_UserAttention$Dom$__f_badgeState = null;
  this.Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState = null;
  this.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixVar = null;
  this.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixSignal = null;
  $n_Lapp_utils_UserAttention$Dom$ = this;
  this.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var(false);
  this.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar.signal__Lcom_raquo_airstream_state_StrictSignal();
  this.Lapp_utils_UserAttention$Dom$__f_badgeState = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
  this.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixVar = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_Lcom_raquo_airstream_state_Var$().apply__O__Lcom_raquo_airstream_state_Var($j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$());
  this.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixSignal = this.Lapp_utils_UserAttention$Dom$__f_pageTitlePrefixVar.signal__Lcom_raquo_airstream_state_StrictSignal();
}
export { $c_Lapp_utils_UserAttention$Dom$ as $c_Lapp_utils_UserAttention$Dom$ };
$c_Lapp_utils_UserAttention$Dom$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_UserAttention$Dom$.prototype.constructor = $c_Lapp_utils_UserAttention$Dom$;
/** @constructor */
function $h_Lapp_utils_UserAttention$Dom$() {
}
export { $h_Lapp_utils_UserAttention$Dom$ as $h_Lapp_utils_UserAttention$Dom$ };
$h_Lapp_utils_UserAttention$Dom$.prototype = $c_Lapp_utils_UserAttention$Dom$.prototype;
$c_Lapp_utils_UserAttention$Dom$.prototype.requestUserAttention__s_concurrent_Future = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar, true);
  $p_Lapp_utils_UserAttention$Dom$__updateSignal__V(this);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_concurrent_Future$().s_concurrent_Future$__f_unit;
});
$c_Lapp_utils_UserAttention$Dom$.prototype.loseUserAttention__s_concurrent_Future = (function() {
  $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_Lcom_raquo_airstream_state_Var__set__O__V(this.Lapp_utils_UserAttention$Dom$__f_needsUserAttentionVar, false);
  $p_Lapp_utils_UserAttention$Dom$__updateSignal__V(this);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_concurrent_Future$().s_concurrent_Future$__f_unit;
});
$c_Lapp_utils_UserAttention$Dom$.prototype.setBadge__s_Option__s_concurrent_Future = (function(number) {
  this.Lapp_utils_UserAttention$Dom$__f_badgeState = number;
  $p_Lapp_utils_UserAttention$Dom$__updateSignal__V(this);
  return $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_s_concurrent_Future$().s_concurrent_Future$__f_unit;
});
var $d_Lapp_utils_UserAttention$Dom$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_utils_UserAttention$Dom$, "app.utils.UserAttention$Dom$", ({
  Lapp_utils_UserAttention$Dom$: 1,
  Lapp_utils_UserAttention: 1
}));
export { $d_Lapp_utils_UserAttention$Dom$ as $d_Lapp_utils_UserAttention$Dom$ };
var $n_Lapp_utils_UserAttention$Dom$;
function $m_Lapp_utils_UserAttention$Dom$() {
  if ((!$n_Lapp_utils_UserAttention$Dom$)) {
    $n_Lapp_utils_UserAttention$Dom$ = new $c_Lapp_utils_UserAttention$Dom$();
  }
  return $n_Lapp_utils_UserAttention$Dom$;
}
export { $m_Lapp_utils_UserAttention$Dom$ as $m_Lapp_utils_UserAttention$Dom$ };
/** @constructor */
function $c_Lapp_utils_UserAttention$Dom$TimerState(timerId) {
  this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId = 0;
  this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId = timerId;
}
export { $c_Lapp_utils_UserAttention$Dom$TimerState as $c_Lapp_utils_UserAttention$Dom$TimerState };
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.constructor = $c_Lapp_utils_UserAttention$Dom$TimerState;
/** @constructor */
function $h_Lapp_utils_UserAttention$Dom$TimerState() {
}
export { $h_Lapp_utils_UserAttention$Dom$TimerState as $h_Lapp_utils_UserAttention$Dom$TimerState };
$h_Lapp_utils_UserAttention$Dom$TimerState.prototype = $c_Lapp_utils_UserAttention$Dom$TimerState.prototype;
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.productIterator__sc_Iterator = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.hashCode__I = (function() {
  var acc = (-889275714);
  var hash = acc;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash, (-651137940));
  var hash$1 = acc;
  var data = this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId;
  acc = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().mix__I__I__I(hash$1, data);
  var hash$2 = acc;
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_Statics$().finalizeHash__I__I__I(hash$2, 1);
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.equals__O__Z = (function(x$0) {
  return ((this === x$0) || ((x$0 instanceof $c_Lapp_utils_UserAttention$Dom$TimerState) && (this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId === x$0.Lapp_utils_UserAttention$Dom$TimerState__f_timerId)));
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.toString__T = (function() {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_sr_ScalaRunTime$()._toString__s_Product__T(this);
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.productArity__I = (function() {
  return 1;
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.productPrefix__T = (function() {
  return "TimerState";
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.productElement__I__O = (function(n) {
  if ((n === 0)) {
    return this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId;
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.productElementName__I__T = (function(n) {
  if ((n === 0)) {
    return "timerId";
  }
  throw $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$ct_jl_IndexOutOfBoundsException__T__(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_jl_IndexOutOfBoundsException(), ("" + n));
});
$c_Lapp_utils_UserAttention$Dom$TimerState.prototype.stop__V = (function() {
  $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_prelude\uff3fclient$package$().window__Lorg_scalajs_dom_Window().clearTimeout(this.Lapp_utils_UserAttention$Dom$TimerState__f_timerId);
  $m_Lapp_utils_UserAttention$Dom$().Lapp_utils_UserAttention$Dom$__f_app$utils$UserAttention$Dom$$$timerState = $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$m_s_None$();
});
function $isArrayOf_Lapp_utils_UserAttention$Dom$TimerState(obj, depth) {
  return (!(!(((obj && obj.$classData) && (obj.$classData.arrayDepth === depth)) && obj.$classData.arrayBase.ancestors.Lapp_utils_UserAttention$Dom$TimerState)));
}
export { $isArrayOf_Lapp_utils_UserAttention$Dom$TimerState as $isArrayOf_Lapp_utils_UserAttention$Dom$TimerState };
var $d_Lapp_utils_UserAttention$Dom$TimerState = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_utils_UserAttention$Dom$TimerState, "app.utils.UserAttention$Dom$TimerState", ({
  Lapp_utils_UserAttention$Dom$TimerState: 1,
  s_Equals: 1,
  s_Product: 1,
  Ljava_io_Serializable: 1
}));
export { $d_Lapp_utils_UserAttention$Dom$TimerState as $d_Lapp_utils_UserAttention$Dom$TimerState };
//# sourceMappingURL=app.utils.-User-Attention$-Dom$.js.map
